import { chakra, EloCardSecondary } from '@plurall/elo-v3';

import { aiInsightCardRecipe } from './ai-insight-card.recipe';

export const AiInsightCardFactory = chakra(EloCardSecondary.Root, aiInsightCardRecipe);
